<template>
	<Accordion
		:open="true"
		:title="$I18n.trans('highlights.audio_detection.tagging.title')"
		icon="c-info"
		:icon-hint="$I18n.trans('highlights.audio_detection.tagging.hint')"
	>
		<div
			v-if="!isIdle"
			class="hl-detection-status"
		>
			<template v-if="isCreated || (isRunning && progressPct === 0)">
				<LoadingSpinner
					class="hl-detection__loading-spinner"
					color="light"
				/><b>{{ $I18n.trans('highlights.audio_detection.tagging.status.starting') }}</b>
			</template>
			<template v-else-if="isRunning && progressPct > 0">
				<LoadingSpinner
					class="hl-detection__loading-spinner"
					color="light"
				/><b>{{ $I18n.trans('highlights.audio_detection.tagging.status.running') }} ({{ progressPct }}%)</b>
			</template>
			<div v-else-if="isCompleted">
				<b>{{ $I18n.trans('highlights.audio_detection.tagging.status.completed') }}</b>
				<Icon
					class="hl-detection-status__icon"
					icon-name="fireworks"
					size="xxxxl"
				/>
				<template v-if="job.createdTags && job.createdTags > 0">
					{{ $I18n.trans('highlights.audio_detection.tagging.summary', {
						created: job.createdTags,
						duration: getDuration(job.totalDuration, { appendUnit: true })
					}) }}
				</template>
			</div>
		</div>
		<div
			v-if="isIdle"
			class="hl-detection-settings"
		>
			<Select
				v-model="settings.profile"
				:clearable="false"
				:searchable="false"
				:dark-theme="true"
				name="profile"
				:label="$I18n.trans('commons.profile')"
				:options="profileOptions"
			/>
			<InputToggle
				v-model="settings.gamePhasesOnly"
				:label="$I18n.trans('highlights.audio_detection.tagging.game_phases_only')"
				:info="$I18n.trans('highlights.audio_detection.tagging.game_phases_info')"
			/>
			<InputToggle
				v-model="settings.createTags"
				:label="$I18n.trans('highlights.audio_detection.tagging.create_tags')"
				:info="$I18n.trans('highlights.audio_detection.tagging.create_tags_info')"
			/>
		</div>
		<button
			v-if="isRunning || isCreated"
			class="button button--responsive button--primary"
			@click="cancelJob"
		>
			{{ $I18n.trans('highlights.audio_detection.tagging.cancel') }}
		</button>
		<button
			v-else-if="!isCompleted"
			class="button button--responsive button--primary"
			@click="initDetection"
		>
			{{ $I18n.trans('highlights.audio_detection.tagging.start') }}
		</button>
		<button
			v-else-if="isCompleted"
			class="button button--responsive button--primary"
			@click="cancelJob"
		>
			{{ transUcfirst('commons.close') }}
		</button>
	</Accordion>
</template>
<script>
import Select from '@shared/components/Select';
import Accordion from '@components/accordion/Accordion';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import InputToggle from '@shared/components/Form/InputToggle';
import { mapGetters, mapActions } from 'vuex';
import { getDuration } from '@shared/utils/timeUtils';
import { getPeriods } from '@js/logic/game';

export default {
	name:       'HighlightSection',
	components: { Accordion, LoadingSpinner, InputToggle, Select },
	data() {
		return {
			settings: {
				gamePhasesOnly: false,
				enhancedAi:     false,
				profile:        'full',
				createTags:     true,
			},
			profileOptions: [
				{
					label: $I18n.trans('highlights.audio_detection.profiles.full'),
					value: 'full',
				},
				{
					label: $I18n.trans('highlights.audio_detection.profiles.audience'),
					value: 'audience',
				},
				{
					label: $I18n.trans('highlights.audio_detection.profiles.referee'),
					value: 'referee',
				},
			],
		};
	},
	computed: {
		...mapGetters({
			state:       'highlights/state',
			job:         'highlights/job',
			isRunning:   'highlights/isRunning',
			isCreated:   'highlights/isCreated',
			isCompleted: 'highlights/isCompleted',
			isIdle:      'highlights/isIdle',
			progressPct: 'highlights/progressPct',
			sportName:   'event/sportName',
			event:       'event/event',
			tags:        'event/tags',
		}),
	},
	watch: {
		tags: {
			handler() {
				if (getPeriods({
					event: this.event,
					tags:  this.tags,
				}).filter(period => period.type === 'action').length > 0) {
					this.settings.gamePhasesOnly = true;
				}
			},
			immediate: false,
		},
	},
	mounted() {
		this.loadJobByEvent();
	},
	methods: {
		...mapActions({
			startDetection: 'highlights/startDetection',
			cancelJob:      'highlights/cancelJob',
			loadJobByEvent: 'highlights/loadJobByEvent',
		}),
		getDuration,
		initDetection: function() {
			this.startDetection(this.settings);
		},
	},
};
</script>

<style lang="scss" scoped>

.hl-detection-status__icon,
.hl-detection__loading-spinner {
	margin: 10px 15px 10px 0;
}

.hl-detection-status {
    display: flex;
    align-items: center;
	margin-bottom: 20px;
}
</style>
